var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    staticClass: "btn btn-primary",
    attrs: {
      type: "submit",
      "data-toggle": "popover",
      "data-container": "body",
      "data-placement": "right",
      "data-content": _vm.message
    },
    domProps: { value: _vm.value },
    on: {
      click: function($event) {
        $event.preventDefault()
        _vm.submit($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80186976", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80186976","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/SubmitButton.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-80186976","hasScoped":false,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./components/SubmitButton.vue
// module chunks = 14